<div
  class="gw-px-medium gw-border-base gw-bg-background-elevation-2 gw-pt-medium gw-pb-medium gw-pr-medium gw-px-medium gw-rounded-2xl gw-mt-x-large gw-flex gw-flex-col gw-transition-all gw-duration-300 gw-border-background-elevation-1"
>
  <div
    class="gw-flex gw-justify-between gw-gap-x-small md:gw-flex-row md:gw-items-center"
    [class.gw-flex-row]="isNew"
    [class.gw-flex-col]="!isNew"
  >
    <div class="gw-flex gw-items-center gw-gap-small">
      <gatewee-icon
        *ngIf="!isNew"
        (click)="emitDelete($event)"
        icon="@tui.trash"
        iconStyle="primary"
        size="20px"
        class="border-icon gw-cursor-pointer gw-border-icon-primary gw-rounded-lg gw-p-2 gw-cursor-pointer"
      ></gatewee-icon>

      <p
        *ngIf="isNew"
        (click)="toggleAccordion()"
        class="gw-text-base gw-font-bold gw-text-text-primary gw-cursor-pointer"
      >
        Novo cliente
      </p>

      <div (click)="toggleAccordion()" class="gw-cursor-pointer" *ngIf="!isNew">
        <p *ngIf="title" class="gw-text-sm gw-font-bold gw-text-text-primary">
          {{ title }}
        </p>
        <p *ngIf="subtitle" class="gw-text-xs gw-text-text-secondary">
          {{ subtitle }}
        </p>
      </div>
    </div>

    <div
      class="gw-flex gw-items-center gw-justify-between md:gw-justify-normal"
    >
      <div
        *ngIf="!isNew"
        class="gw-flex gw-items-center gw-p-3x-small gw-rounded-full"
        [style.background]="badgeBgColor"
        [ngClass]="configBadge.status ? 'gw-badge-success' : 'gw-badge-failed'"
      >
        <i
          class="fa-regular gw-mr-3x-small"
          [ngClass]="badgeIcon"
          [style.color]="badgeTextColor"
        ></i>
        <span class="gw-text-xs" [style.color]="badgeTextColor">
          {{ badgeLabel }}
        </span>
      </div>

      <div *ngIf="!isNew" class="divider"></div>

      <div
        (click)="toggleAccordion()"
        class="gw-flex gw-items-center gw-cursor-pointer"
      >
        <p
          *ngIf="!isNew"
          class="gw-pr-3x-small gw-text-xs gw-text-text-secondary"
        >
          Informações do cliente
        </p>

        <div
          class="gw-border-base gw-p-[8px]"
          *ngIf="isNew"
          (click)="emitDelete($event)"
        >
          <gatewee-icon
            icon="@tui.x"
            size="16px"
            iconStyle="outline"
          ></gatewee-icon>
        </div>

        <i
          *ngIf="!isNew"
          class="fa-solid fa-chevron-down gw-transition-transform gw-duration-200"
          [ngClass]="{'gw-rotate-180': accordionOpen}"
        ></i>
      </div>
    </div>
  </div>

  <div
    class="gw-overflow-hidden gw-transition-all gw-duration-500"
    [style.maxHeight]="accordionOpen ? '100%' : '0px'"
  >
    <div class="gw-mt-medium">
      <ng-content></ng-content>
    </div>
  </div>
</div>
